import { styled } from "@mui/material";
import React from "react";
import { pxToRem } from "../../../../platform-style";

interface IndicatorDotProps {
  size: number;
}

export const IndicatorDot = styled("span", {
  shouldForwardProp: (prop) => prop !== "size",
})<IndicatorDotProps>(({ theme, size }) => ({
  borderRadius: "100%",
  border: `${pxToRem(size)} solid ${theme.palette.text.disabled}BF`,
  margin: pxToRem(size * 1.25),
  "&:nth-of-type(1)": {
    animation: "preloader .3s ease-in-out alternate infinite",
  },
  "&:nth-of-type(2)": {
    animation: "preloader .3s ease-in-out alternate .2s infinite",
  },
  "&:nth-of-type(3)": {
    animation: "preloader .3s ease-in-out alternate .4s infinite",
  },
  "@keyframes preloader": {
    "100%": { transform: "scale(1.5)" },
  },
})) as React.ComponentType<IndicatorDotProps>;
